import React from "react";
import Modal from "antd/lib/modal";
import Input from "antd/lib/input";
import { wrap as wrapDialog, DialogPropType } from "@/components/dialog-wrapper/DialogWrapper";
import { useTheme } from "@/components/ThemeProvider";
import "./CreateGroupDialog.less";

function CreateGroupDialog({ dialog }) {
  const [name, setName] = React.useState("");
  const { isDarkMode } = useTheme();

  const save = () => {
    dialog.close({ name });
  };

  return (
    <Modal
      {...dialog.props}
      title="Create a New Group"
      okText="Create"
      onOk={save}
      className={`create-group-dialog ${isDarkMode ? "dark-mode" : ""}`}
    >
      <Input
        className="form-control"
        value={name}
        onChange={event => setName(event.target.value)}
        onPressEnter={save}
        placeholder="Group Name"
        aria-label="Group name"
        autoFocus
      />
    </Modal>
  );
}

CreateGroupDialog.propTypes = {
  dialog: DialogPropType.isRequired,
};

export default wrapDialog(CreateGroupDialog);
